module.exports = __webpack_public_path__ + "img/start_1.2b478feb.svg";